/**
 * Spinner (P142) -- a small brass rotating ring. Decorative liveness
 * indicator; `aria-hidden` (the surrounding EngineBusy carries the
 * accessible text). Respects reduced-motion: `motion-reduce:animate-none`
 * freezes the ring (the elapsed counter still conveys liveness).
 */
interface SpinnerProps {
  /** Tailwind size classes, e.g. "h-3.5 w-3.5". Defaults to a small ring. */
  className?: string;
}

export function Spinner({ className = "h-3.5 w-3.5" }: SpinnerProps) {
  return (
    <span
      data-testid="spinner"
      aria-hidden="true"
      className={[
        "inline-block shrink-0 rounded-full border-2 border-brand-brass/30 border-t-brand-brass",
        "animate-spin motion-reduce:animate-none",
        className,
      ].join(" ")}
    />
  );
}
